module.exports = __webpack_public_path__ + "static/media/bronze_link_banner_en.89f98ff7.png";